import { Building2 } from 'lucide-react'
import { useOpCo } from '../../context/OpCoContext'

// Small OpCo chips for request lists, the request header and the dashboard.
// Every export renders nothing unless the OpCo workspace is enabled, so with
// the flag off (or in a normal workspace, where noted) the UI is unchanged.

const CHIP = 'inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap'

export function isUnassigned(request) {
  return !request?.opco_code && !request?.opco_id
}

// Code chip, or an amber "Unassigned" chip when the request has no OpCo.
export function OpCoChip({ code, name }) {
  if (!code) {
    return (
      <span className={`${CHIP} bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300`}>
        Unassigned
      </span>
    )
  }
  return (
    <span
      className={`${CHIP} bg-navy-100 text-navy-700 dark:bg-navy-900/30 dark:text-navy-300`}
      title={name && name !== code ? name : undefined}
    >
      <Building2 className="h-2.5 w-2.5" />
      {code}
    </span>
  )
}

// Requests list column: only in an OpCo admin's "All OpCos" view.
export function OpCoColumnHeader() {
  const { allOpcos } = useOpCo()
  if (!allOpcos) return null
  return (
    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 tracking-wide whitespace-nowrap">
      OpCo
    </th>
  )
}

export function OpCoColumnCell({ request }) {
  const { allOpcos } = useOpCo()
  if (!allOpcos) return null
  return (
    <td className="px-4 py-3.5">
      <OpCoChip code={request?.opco_code} name={request?.opco_name} />
    </td>
  )
}

// Dashboard heading chip for the "All OpCos" view.
export function AllOpCosChip() {
  const { allOpcos } = useOpCo()
  if (!allOpcos) return null
  return (
    <span className="ml-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full align-middle text-xs font-semibold bg-navy-100 text-navy-700 dark:bg-navy-900/30 dark:text-navy-300">
      <Building2 className="h-3 w-3" />
      All OpCos
    </span>
  )
}

// Request header badge: only useful when the user can see more than one OpCo.
export default function OpCoBadge({ request }) {
  const { enabled, isOpcoAdmin, opcos } = useOpCo()
  if (!enabled || !request) return null
  if (!isOpcoAdmin && (opcos?.length || 0) <= 1) return null
  return <OpCoChip code={request.opco_code} name={request.opco_name} />
}
